// extracted by mini-css-extract-plugin
module.exports = {"crumbs":"Pagination_crumbs__3aNFX","crumb":"Pagination_crumb__mr_yH","crumb__active":"Pagination_crumb__active__2m6Pv"};